<template>
  <div class="container">
    <HeaderCom />

      <div class="banner bannerhref" ref="banner">
          <div class="swiper banner_swiper" ref="bannerSwiper">
            <div class="swiper-wrapper">
              <!-- 视频 slide -->
              <div class="swiper-slide">
                <div class="video">
                  <video autoplay muted loop playsinline="playsinline" object-fit="cover" >
                    <source src="http://oss-hk.sd-ms.cn/video/2.mp4" type="video/mp4" /> 
                    Your browser does not support the video tag.
                  </video> 
                </div>
                <div class="video_mask">
                  <img src="../assets/images/mask.png" alt="">
                </div>
                <div class="solgan">
                  <img src="../assets/images/solgan_icon.png" alt="" class="solgan_icon">
                  <h2>{{ bannerItems[0].title }}</h2>
                  <h5>{{ bannerItems[0].subtitle }}</h5>
                  <a href="javascript:void(0)" class="solgan_btn" @click="goToAbout">
                    <span>查看更多</span>
                    <img src="../assets/images/icon_small_right.png" alt="">
                  </a>
                </div>
                
              </div>
              <!-- 图片 slide 1 -->
              <div class="swiper-slide">
                <div class="banner_image">
                  <img src="../assets/images/banner_about.jpg" alt="">
                </div>
                <div class="video_mask">
                  <img src="../assets/images/mask.png" alt="">
                </div>
                <div class="solgan">
                  <img src="../assets/images/solgan_icon.png" alt="" class="solgan_icon">
                  <h2>{{ bannerItems[1].title }}</h2>
                  <h5>{{ bannerItems[1].subtitle }}</h5>
                  <a href="javascript:void(0)" class="solgan_btn" @click="goToAbout">
                    <span>查看更多</span>
                    <img src="../assets/images/icon_small_right.png" alt="">
                  </a>
                </div>
                
              </div>
              <!-- 图片 slide 2 -->
              <div class="swiper-slide">
                <div class="banner_image">
                  <img src="../assets/images/index_bg_3.jpg" alt="">
                </div>
                <div class="video_mask">
                  <img src="../assets/images/mask.png" alt="">
                </div>
                <div class="solgan">
                  <img src="../assets/images/solgan_icon.png" alt="" class="solgan_icon">
                  <h2>{{ bannerItems[2].title }}</h2>
                  <h5>{{ bannerItems[2].subtitle }}</h5>
                  <a href="javascript:void(0)" class="solgan_btn" @click="goToProduct">
                    <span>查看更多</span>
                    <img src="../assets/images/icon_small_right.png" alt="">
                  </a>
                </div>
                
              </div>
            </div>
            <div class="cursor">
                  <img src="../assets/images/icon_mouse.png" alt="">
                  <p>向下滑动</p>
                </div>
            <!-- 分页器 -->
            <div class="swiper-pagination banner_pagination"></div>
            <!-- 导航按钮 -->
            <div class="banner_nav_prev">
              <img src="../assets/images/icon_left_white.png" alt="">
            </div>
            <div class="banner_nav_next">
              <img src="../assets/images/icon_right_white.png" alt="">
            </div>
            
          </div>
      </div>

      <div class="setion_one">
          <div class="setion_one_left">
              <img
                v-for="(item, index) in sectionOneConfigs"
                :key="index"
                :src="item.img"
                alt=""
                class="img"
                :class="{ img1: index === 0, active: index === activeSectionOneIndex }"
              >
          </div>
          <div class="setion_one_title">
            <div class="title_index">
              <h4>ABOUT MIRSHINE</h4>
              <h5><span>走进明晟</span> <em></em></h5>
            </div>
          </div>
          <div class="setion_one_right">
               <div class="setion_one_right_inner">
                  <img src="../assets/images/index_bg_1.jpg" alt="" class="bg">
                  <h2 v-html="currentSectionOne.h2"></h2>
                  <h3 v-html="currentSectionOne.h3"></h3>
                    
                    <a href="javascript:void(0)" class="circular_more" @click="goToAbout">
                        <img src="../assets/images/icon_right_green.png" alt="" class="img1">
                        <img src="../assets/images/icon_right_white.png" alt="" class="img2">
                    </a>
                   
              </div>
              <div class="setion_one_right_inner_right">
                  <h6>MIRSHINE</h6>
                  <p></p>
              </div>
          </div>
      </div>

      <div class="setion_two">
          <a
            v-for="(item, index) in sectionOneConfigs"
            :key="index"
            href="javascript:void(0)"
            class="setion_two_item"
            @mouseenter="handleSectionTwoHover(index)"
          >
            <img :src="item.logo" alt="">
          </a>
      </div>


      <div class="setion_three">
          <div class="setion_three_bg">
              <div
                class="setion_three_bg_item setion_three_bg_item1"
                :class="{ active: activeThreeIndex === 0 }"
              >
                <img src="../assets/images/index_bg_3.jpg" alt="">
              </div>
              <div
                class="setion_three_bg_item"
                :class="{ active: activeThreeIndex === 1 }"
              >
                <img src="../assets/images/index_bg_3_2.jpg" alt="">
              </div>
              <div
                class="setion_three_bg_item"
                :class="{ active: activeThreeIndex === 2 }"
              >
                <img src="../assets/images/index_bg_3_3.jpg" alt="">
              </div>
              <div
                class="setion_three_bg_item"
                :class="{ active: activeThreeIndex === 3 }"
              >
                <img src="../assets/images/index_bg_3_4.jpg" alt="">
              </div>
              <div
                class="setion_three_bg_item"
                :class="{ active: activeThreeIndex === 4 }"
              >
                <img src="../assets/images/index_bg_3_5.jpg" alt="">
              </div>
              <div
                class="setion_three_bg_item"
                :class="{ active: activeThreeIndex === 5 }"
              >
                <img src="../assets/images/index_bg_3_6.jpg" alt="">
              </div>
          </div>
          <div class="lines lines1"></div>
          <div class="lines lines2"></div>
          <div class="lines lines3"></div>
          <div class="lines lines4"></div>
          <div class="lines lines5"></div>
         
          <div class="setion_three_box clearfix">
            <div
              class="setion_three_item"
              :class="{ active: activeThreeIndex === 0 }"
              @mouseenter="setActiveThree(0)"
              @click="goToProductView(1)"
            >
              <div class="setion_three_item_inner">
                <h3>01</h3>
                <img src="../assets/images/icon_img_1.png" alt="" class="icon">
                <h4>氨法脱硫（烟气治理）</h4>
                <h5>Ammonia-based Desu<br>furization <br>(Flue Gas Treatment)</h5>
                <p>氨法脱硫技术以"梯级分离净化"为核心，实现SO₂浓度≤35mg/Nm³、氨逃逸<2mg/Nm³的超低排放，形成"污染治理+资源再生"闭环。 </p>
                <a href="javascript:void(0)" class="circular_more" >
                    <img src="../assets/images/icon_right_green.png" alt="" class="img1">
                    <img src="../assets/images/icon_right_white.png" alt="" class="img2">
                </a>
              </div>
            </div>
            <div
              class="setion_three_item"
              :class="{ active: activeThreeIndex === 1 }"
              @mouseenter="setActiveThree(1)"
              @click="goToProductView(2)"
            >
              <div class="setion_three_item_inner">
                <h3>02</h3>
                <img src="../assets/images/icon_img_2.png" alt="" class="icon">
                <h4>烟道插板阀</h4>
                <h5>Flue <br>Gate Valve</h5>
                <p>工业烟道插板阀的发明者，通过结构性创新，解决传统设备卡滞、泄漏痛点，实现零泄漏、低能耗和长寿命运行。</p>
                <a href="javascript:void(0)" class="circular_more" >
                    <img src="../assets/images/icon_right_green.png" alt="" class="img1">
                    <img src="../assets/images/icon_right_white.png" alt="" class="img2">
                </a>
              </div>
            </div>
            <div
              class="setion_three_item"
              :class="{ active: activeThreeIndex === 2 }"
              @mouseenter="setActiveThree(2)"
              @click="goToProductView(3)"
            >
              <div class="setion_three_item_inner">
                <h3>03</h3>
                <img src="../assets/images/icon_img_3.png" alt="" class="icon">
                <h4>轮胎裂解</h4>
                <h5>Tire<br>Pyrolysis</h5>
               <p>安全处理废旧轮胎，解决环境污染问题，实现炭黑等产物的品质升级与资源化利用，兼具环保与经济效益。</p>
                <a href="javascript:void(0)" class="circular_more" >
                    <img src="../assets/images/icon_right_green.png" alt="" class="img1">
                    <img src="../assets/images/icon_right_white.png" alt="" class="img2">
                </a>
              </div>
            </div>
            <div
              class="setion_three_item"
              :class="{ active: activeThreeIndex === 3 }"
              @mouseenter="setActiveThree(3)"
              @click="goToProductView(4)"
            >
              <div class="setion_three_item_inner">
                <h3>04</h3>
                <img src="../assets/images/icon_img_4.png" alt="" class="icon">
                <h4>压力容器 </h4>
                <h5>Pressure<br>Vessels</h5>
                <p>深耕压力容器制造领域，凭借核心专利技术，专注于高压、低温等极端工况装备研发，产品符合国际与国内标准。</p>
                <a href="javascript:void(0)" class="circular_more" >
                    <img src="../assets/images/icon_right_green.png" alt="" class="img1">
                    <img src="../assets/images/icon_right_white.png" alt="" class="img2">
                </a>
              </div>
            </div>
            <div
              class="setion_three_item"
              :class="{ active: activeThreeIndex === 4 }"
              @mouseenter="setActiveThree(4)"
              @click="goToProductView(5)"
            >
              <div class="setion_three_item_inner">
                <h3>05</h3>
                <img src="../assets/images/icon_img_5.png" alt="" class="icon">
                <h4>工程安装</h4>
                <h5>Engineering Installation<br>& Commissioning Fire</h5>
                <p>具备完善的安装资质与丰富经验，可为环保项目提供全流程的安装调试与专业技术支持服务。</p>
                <a href="javascript:void(0)" class="circular_more">
                    <img src="../assets/images/icon_right_green.png" alt="" class="img1">
                    <img src="../assets/images/icon_right_white.png" alt="" class="img2">
                </a>
              </div>
            </div>
            <div
              class="setion_three_item"
              :class="{ active: activeThreeIndex === 5 }"
              @mouseenter="setActiveThree(5)"
              @click="goToProductView(6)"
            >
              <div class="setion_three_item_inner">
                <h3>06</h3>
                <img src="../assets/images/icon_img_6.png" alt="" class="icon">
                <h4>运维服务</h4>
                <h5>Operations & Maintenance<br>Services</h5>
                <p>以化工思维进行数据驱动的预防性维护，将环保设施从成本中心转化为价值创造单元，为客户持续创造绿色价值。</p>
                  <a href="javascript:void(0)" class="circular_more" >
                    <img src="../assets/images/icon_right_green.png" alt="" class="img1">
                    <img src="../assets/images/icon_right_white.png" alt="" class="img2">
                </a>
              </div>
            </div>


          </div>
      </div>


      <div class="setion_three_m">
        <div class="setion_three_m_bg">
          <div
            class="setion_three_m_bg_item"
            v-for="(item, index) in sectionThreeItems"
            :key="index"
            :class="{ active: activeThreeMIndex === index }"
          >
            <img :src="item.bgImg" alt="">
          </div>
        </div>
        <div class="swiper setion_three_m_swiper" ref="threeMSwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in sectionThreeItems"
              :key="index"
            >
              <div class="setion_three_m_item" @click="goToProductView(item.id)">
                <div class="setion_three_m_item_inner">
                  <h3>{{ item.number }}</h3>
                  <img :src="item.icon" alt="" class="icon">
                  <h4>{{ item.title }}</h4>
                  <h5 v-html="item.subtitle"></h5>
                  <p>{{ item.desc }}</p>
                  <a href="javascript:void(0)" class="circular_more" @click="goToAbout">
                    <img src="../assets/images/icon_right_green.png" alt="" class="img1">
                    <img src="../assets/images/icon_right_white.png" alt="" class="img2">
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>

      <div class="setion_sevens">
        <div class="content2">
          <div class="title_index">
              <h4>HONORS</h4>
              <h5><span>资质荣誉</span> <em></em></h5>
            </div>
        </div>
        <div class="content clearfix">
          <div class="honors_content">
            <div class="honors_bg"></div>
            <div class="honors_content_item">
                <img src="../assets/images/honors1.png" alt="">
            </div>
          </div>
          <a class="honor_more" href="javascript:void(0)" @click.prevent="goToAboutHonors">
                  <span>查看更多</span>
                  <img src="../assets/images/icon_small_right.png" alt="">
              </a>
        
        </div>
      </div>

      <div class="setion_four">
        <div class="content2">
          <div class="title_index">
              <h4>SERVING CUSTOMERS</h4>
              <h5><span>服务客户</span> <em></em></h5>
            </div>

            <div class="panter">
              <div class="panter_item">
                <img src="../assets/images/logo/logo1.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo2.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo3.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo9.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo10.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo11.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo12.jpg" alt="">
              </div>

              <div class="panter_item">
                <img src="../assets/images/logo/logo4.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo5.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo6.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo15.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo16.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo17.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo18.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo7.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo19.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo8.jpg" alt="">
              </div>

              

             

              <div class="panter_item">
                <img src="../assets/images/logo/logo20.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo21.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo22.jpg" alt="">
              </div>
              <div class="panter_item">
                <img src="../assets/images/logo/logo23.jpg" alt="">
              </div>
             
              
              
        
              



            </div>

        </div>
      </div>


<div class="setion_five">
  <div class="setion_five_left">
    <img src="../assets/images/index_bg_4.jpg" alt="" class="setion_five_left_pc">
    <div class="setion_five_left_inner">
          <div class="title_index">
            <h4>NEWS</h4>
            <h5><span>新闻中心</span> <em></em></h5>
          </div>
          <div class="five_btn">
            <div class="five_btn_prev" >
                <img src="../assets/images/icon_left_white.png" alt="">
            </div>
            <div class="five_btn_next" >
              <img src="../assets/images/icon_right_white.png" alt="">
            </div>
          </div>
    </div>
  </div>
  <div class="setion_five_right">
    <div class="swiper" ref="fiveSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in newsItems" :key="index">
          <div
            class="setion_five_item"
            @click="goToNewsDetail(item)"
            style="cursor: pointer;"
          >
            <div class="setion_five_img">
              <img :src="item.image" :alt="item.title">
            </div>
            <div class="setion_five_desp">
              <h3>{{ item.title }}</h3>
              <h6>{{ item.desc }}</h6>
            </div>
            <p>
              <span>{{ item.date }}</span>
              <font>
                <em>VIEW MORE</em>
                <img src="../assets/images/icon_right_greens.png" alt="">
              </font>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



      <div class="setion_six">
        
           <div class="title_index">
              <h4>GLOBAL&PRESENCE</h4>
              <h5><span>全球办公室</span> <em></em></h5>
            </div>

            <div class="setion_six_content">
              <img src="../assets/images/index_map.jpg" alt="" class="img1"/>
              <img src="../assets/images/index_map_m.jpg" alt="" class="img2"/>
              
            </div>
              <div class="setion_six_text">
                <div class="setion_six_text_top">
                  <span>中国</span>
                  <font>CHINA</font>
                </div>
                <div class="ul">
                  <div class="li">
                    <b>地址:</b>
                    <p>山东省济南市章丘区龙山产业园3号路</p>
                  </div>
                  <div class="li">
                    <b>国内:</b>
                    <p>+86 185 6023 8118</p>
                  </div>
                  <div class="li">
                    <b>海外:</b>
                    <p>+86 156 6577 1608</p>
                  </div>
                 
                  <div class="li">
                    <b>邮箱:</b>
                    <p>Brand@sd-ms.cn</p>
                  </div>
                </div>



              </div>

       
      </div>
      <FooterCom />

     
                   


  </div>
</template>

<script>

import HeaderCom from '../components/HeaderCom.vue';  
import FooterCom from '../components/FooterCom.vue';
import { getMediaPage } from '@/api/media'
// 使用 swiper 核心包
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default {
  components: { HeaderCom ,FooterCom},
  data () {
    return {
      bannerSwiperInstance: null,
      // Banner 配置数据
      bannerItems: [
        {
          type: 'video',
          title: '绿色低碳循环经济',
          subtitle: 'Green, Low-Carbon, Circular Economy'
        },
        {
          type: 'image',
          title: '双甲级资质，承接全球项目',
          subtitle: 'Double class a qualification to undertake global projects'
        },
        {
          type: 'image',
          title: '氨法脱硫技术 国际先进',
          subtitle: 'Ammonia desulfurization technology is internationally advanced'
        }
      ],
      // 默认第一个为激活状态
      activeThreeIndex: 0,
      // 关于版块当前激活索引（由 setion_two_item 悬停控制）
      activeSectionOneIndex: 0,
      // 关于版块配置：合作 logo + 左侧图片 + 右侧文案
      sectionOneConfigs: [
        {
          
          logo: require('../assets/images/i_logo5.png'),
          img: require('../assets/images/index_bg_2.jpg'),
          h2: '从齐鲁大地到全球角落<br>我们以二十年匠心守护每一片蓝天',
          h3: '作为全球环境领域的创新引领者，明晟环保集团以“改善人类生存环境，提升人民生活品质”为使命，自2005年创立以来，始终致力于通过科技创新推动全球环保事业的发展，现已从一家专业氨法脱硫技术公司，发展成为集环保技术与设备研发、设计、制造、施工与运营于一体的综合性企业，业务涵盖大气治理、水处理、固废处理、压力容器制造与安装、环保运维、智能设备制造等多元领域。'
        },
        
        {
          logo: require('../assets/images/i_logo11.png'),
          img: require('../assets/images/index_bg_2_3.jpg'),
          h2: '明晟环保设备​有限公司',
          h3: '明晟环保设备专注固废资源化与特种设备制造，核心产品包括轮胎裂解设备、压力容器及压力管道，具备A2级压力容器制造资质。该资质要求具备小于等于10MP非球型第三类低中压压力容器制造能力，需配备专业工程师、无损检测人员及专用设备，彰显公司在高难度特种设备领域的硬实力。公司轮胎裂解设备采用低温微负压连续工艺，将废轮胎转化为燃油、炭黑等再生资源，提供从定制到运维的一体化解决方案，推动循环经济发展。'
        },
        
        {
          logo: require('../assets/images/i_logo10.png'),
          img: require('../assets/images/index_bg_2_7.jpg'),
          h2: '明晟（海南）环保​科技有限公司',
          h3: '明晟（海南）环保依托海南自贸港政策与区位优势，聚焦环保领域的国际贸易与资源整合，主营设备进出口、技术许可及耗材跨境供应。公司构建了连接全球市场的贸易桥梁，产品覆盖大气治理、水处理、固废处理等全品类环保装备，并提供国际标准适配、清关与技术本土化等增值服务。通过引进先进技术与推动国产装备“走出去”，明晟环保致力于成为全球环保合作的重要纽带，赋能绿色低碳发展。'
        },
        {
          logo: require('../assets/images/i_logo1.png'),
          img: require('../assets/images/index_bg_2_10.jpg'),
          h2: 'MIRSHINE',
          h3: '明晟环保科技作为大气治理领域的高新技术企业，以氨法脱硫技术为核心，为电力、钢铁、化工等行业提供烟气治理解决方案。公司通过自主研发的氨法脱硫工艺，实现二氧化硫高效脱除与副产物资源化，兼具环境与经济效益。业务覆盖设计、制造、施工、运维全链条，已服务多项大型工业项目，助力企业达标排放与绿色转型，为蓝天保卫战提供技术支撑。'
        },
        {
          logo: require('../assets/images/i_logo4.png'),
          img: require('../assets/images/index_bg_2_8.jpg'),
          h2: '明晟生态研究院​',
          h3: '生态研究院是专注环保技术研发与成果转化的专业机构，研究方向涵盖大气治理、水处理、固废资源化、生态修复及低碳技术等领域。研究院拥有专家团队与先进实验平台，坚持“产学研用”结合，与高校、企业及政府合作攻关行业技术难题，推动科研成果落地。同时为企业提供技术咨询、研发支持与人才培养服务，助力环保产业升级与生态文明建设。'
        },
        {
          logo: require('../assets/images/i_logo8.png'),
          img: require('../assets/images/index_bg_2_9.jpg'),
          h2: '山东盛泰安装设备有限公司​',
          h3: '盛泰安装设备有限公司专注于环保装备的安装与工程服务，具备完备资质与丰富项目经验。公司业务涵盖大气治理、水处理、固废系统及压力容器等设备的安装、调试与改造，拥有专业施工团队，能根据项目需求制定科学方案，确保工程质量与安全。已服务多项市政与工业环保项目，以高效施工与可靠售后成为环保设备稳定运行的重要保障。'
        },
        {
          logo: require('../assets/images/i_logo3.png'),
          img: require('../assets/images/index_bg_2_2.jpg'),
          h2: '德州众生环保​有限公司',
          h3: '德州众生环保是专注于环保专用阀门的研发与制造企业，核心产品包括电动液压阀门、电动阀门等，主打“克劳森”品牌烟气挡板阀。公司依托先进技术自主创新，其电动液压插板阀采用菱形力学设计，具备密封严、耐高温、抗卡阻等优势，维护成本较传统阀门降低约70%。产品广泛应用于电力、化工、焦化等行业的烟气脱硫系统及烟风管道，以精密数控加工与完善服务体系，为工业烟气治理提供关键设备支撑。'
        },
        
      ],
      fiveSwiperInstance: null,
      threeMSwiperInstance: null,
      activeThreeMIndex: 0,
      sectionThreeItems: [
        {
          id:1,
          number: '01',
          icon: require('../assets/images/icon_img_1.png'),
          title: '氨法脱硫（烟气治理）',
          subtitle: 'Ammonia-based Desu<br>furization <br>(Flue Gas Treatment)',
          desc: '氨法脱硫技术以"梯级分离净化"为核心，实现SO₂浓度≤35mg/Nm³、氨逃逸<2mg/Nm³的超低排放，形成"污染治理+资源再生"闭环。',
          bgImg: require('../assets/images/index_bg_3.jpg')
        },
        {
          id:2,
          number: '02',
          icon: require('../assets/images/icon_img_2.png'),
          title: '烟道插板阀',
          subtitle: 'Flue <br>Gate Valve',
          desc: '工业烟道插板阀的发明者，通过结构性创新，解决传统设备卡滞、泄漏痛点，实现零泄漏、低能耗和长寿命运行。',
          bgImg: require('../assets/images/index_bg_3_2.jpg')
        },
        {
          id:3,
          number: '03',
          icon: require('../assets/images/icon_img_3.png'),
          title: '轮胎裂解',
          subtitle: 'Tire<br>Pyrolysis',
          desc: '安全处理废旧轮胎，解决环境污染问题，实现炭黑等产物的品质升级与资源化利用，兼具环保与经济效益',
          bgImg: require('../assets/images/index_bg_3_3.jpg')
        },
        {
          id:4,
          number: '04',
          icon: require('../assets/images/icon_img_4.png'),
          title: '压力容器',
          subtitle: 'Pressure<br>Vessels',
          desc: '深耕压力容器制造领域，凭借核心专利技术，专注于高压、低温等极端工况装备研发，产品符合国际与国内标准。',
          bgImg: require('../assets/images/index_bg_3_4.jpg')
        },
        {
          id:5,
          number: '05',
          icon: require('../assets/images/icon_img_5.png'),
          title: '工程安装',
          subtitle: 'Engineering Installation<br>& Commissioning Fire',
          desc: '具备完善的安装资质与丰富经验，可为环保项目提供全流程的安装调试与专业技术支持服务。',
          bgImg: require('../assets/images/index_bg_3_5.jpg')
        },
        {
          id:6,
          number: '06',
          icon: require('../assets/images/icon_img_6.png'),
          title: '运维服务',
          subtitle: 'Operations & Maintenance<br>Services',
          desc: '以化工思维进行数据驱动的预防性维护，将环保设施从成本中心转化为价值创造单元，为客户持续创造绿色价值。',
          bgImg: require('../assets/images/index_bg_3_6.jpg')
        }
      ],
      newsItems: []
    }
  },
  computed: {
    currentSectionOne () {
      if (!this.sectionOneConfigs || this.sectionOneConfigs.length === 0) return {}
      const index = this.activeSectionOneIndex
      return this.sectionOneConfigs[index] || this.sectionOneConfigs[0]
    }
  },
  methods: {
    // 初始化 banner swiper
    initBannerSwiper() {
      if (this.bannerSwiperInstance) {
        this.bannerSwiperInstance.destroy(true, true)
        this.bannerSwiperInstance = null
      }
      const el = this.$refs.bannerSwiper
      if (!el) return

      this.bannerSwiperInstance = new Swiper(el, {
        modules: [Navigation, Pagination, Autoplay],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        speed: 1000,
        pagination: {
          el: '.banner_pagination',
          clickable: true,
          bulletClass: 'banner_bullet',
          bulletActiveClass: 'banner_bullet_active',
        },
        navigation: {
          nextEl: '.banner_nav_next',
          prevEl: '.banner_nav_prev',
        },
      })
    },
    setActiveThree (index) {
      this.activeThreeIndex = index
    },
    handleSectionTwoHover (index) {
      this.activeSectionOneIndex = index
    },
    initFiveSwiper () {
      if (this.fiveSwiperInstance) {
        this.fiveSwiperInstance.destroy(true, true)
        this.fiveSwiperInstance = null
      }
      const el = this.$refs.fiveSwiper
      if (!el) return
      
      // 如果数据为空，不初始化 swiper
      if (!this.newsItems || this.newsItems.length === 0) {
        return
      }

      // 等待图片加载完成
      const images = el.querySelectorAll('img')
      let loadedCount = 0
      const totalImages = images.length
      
      if (totalImages === 0) {
        // 如果没有图片，直接初始化
        this.createFiveSwiper(el)
        return
      }

      const checkImagesLoaded = () => {
        loadedCount++
        if (loadedCount === totalImages) {
          // 所有图片加载完成后，再初始化 swiper
          this.$nextTick(() => {
            this.createFiveSwiper(el)
          })
        }
      }

      images.forEach((img) => {
        if (img.complete) {
          checkImagesLoaded()
        } else {
          img.addEventListener('load', checkImagesLoaded)
          img.addEventListener('error', checkImagesLoaded)
        }
      })
    },
    createFiveSwiper(el) {
      // 检测是否为 PC 端
      const isPC = window.innerWidth >= 768
      const pcSlidesPerView = 3
      const mobileSlidesPerView = 1.5
      const currentSlidesPerView = isPC ? pcSlidesPerView : mobileSlidesPerView
      
      // 如果数据量少于或等于 slidesPerView，禁用 loop（PC 端 3 条数据显示 3 个，无法 loop）
      // 如果数据量大于 slidesPerView，启用 loop
      const shouldLoop = this.newsItems.length > currentSlidesPerView
      
      const swiperConfig = {
        modules: [Navigation], // 使用 Navigation 模块
        direction: 'horizontal',
        slidesPerView: mobileSlidesPerView,
        spaceBetween: '5%',
        loop: true,
        speed: 600,
        navigation: {
          nextEl: '.five_btn_next',
          prevEl: '.five_btn_prev',
        },
        breakpoints: {
          768: {
            slidesPerView: pcSlidesPerView,
            spaceBetween: '5%',
          }
        },
        on: {
          init: () => {
            if (this.fiveSwiperInstance) {
              this.fiveSwiperInstance.update()
            }
          }
        }
      }
      
    
      
      this.fiveSwiperInstance = new Swiper(el, swiperConfig)
    },
   
    initThreeMSwiper () {
      if (this.threeMSwiperInstance) {
        this.threeMSwiperInstance.destroy(true, true)
      }
      const el = this.$refs.threeMSwiper
      if (!el) return

      this.threeMSwiperInstance = new Swiper(el, {
        modules: [Pagination],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          slideChange: (swiper) => {
            // 更新背景图片索引
            const realIndex = swiper.realIndex
            this.activeThreeMIndex = realIndex
          }
        }
      })
    },
    // 获取图片URL
    getImageUrl(imageUrl) {
      if (!imageUrl) {
        return require('../assets/images/demo_news_1.jpg')
      }
      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl
      }
      if (imageUrl.startsWith('/')) {
        const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://api.sd-ms.cn'
        return baseURL + imageUrl
      }
      return require('../assets/images/demo_news_1.jpg')
    },
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}.${month}.${day}`
    },
    // 获取新闻列表数据
    async fetchNewsList() {
      try {
        // 需要请求 4 次接口：mediaType 1/2/3/4，然后合并渲染
        const mediaTypes = ['1', '2', '3', '4']
        const requests = mediaTypes.map((mediaType) => {
          return getMediaPage({
            pageNo: 1,
            pageSize: 6,
            mediaType,
            mediaIndexTop: '0'
          }).catch((err) => {
            console.error(`获取新闻列表失败 mediaType=${mediaType}:`, err)
            return null
          })
        })

        const responses = await Promise.all(requests)
        const mergedList = responses
          .map((res) => (res && res.data && Array.isArray(res.data.list) ? res.data.list : []))
          .flat()

        if (mergedList.length > 0) {
          // 合并后按 mediaSort 排序（数值越小越靠前）
          mergedList.sort((a, b) => {
            const sortA = a.mediaSort != null ? Number(a.mediaSort) : 999999
            const sortB = b.mediaSort != null ? Number(b.mediaSort) : 999999
            return sortA - sortB
          })

          this.newsItems = mergedList.map((item) => {
            return {
              id: item.id,
              mediaType: item.mediaType,
              image: this.getImageUrl(item.mediaImage),
              title: item.mediaTitle || '暂无标题',
              desc: item.mediaDesc || item.mediaTitle || '暂无描述',
              date: this.formatDate(item.mediaDate || item.createTime)
            }
          })
        } else {
          // 如果返回数据为空，使用默认数据
          this.newsItems = [
            {
              id: null,
              mediaType: null,
              image: require('../assets/images/demo_news_1.jpg'),
              title: '暂无新闻',
              desc: '暂无新闻内容',
              date: ''
            }
          ]
        }
        
        // 数据加载完成后，初始化 swiper
        // 使用双重 $nextTick 确保 DOM 完全更新，并添加小延迟确保图片加载
        this.$nextTick(() => {
          this.$nextTick(() => {
            setTimeout(() => {
              this.initFiveSwiper()
            }, 100)
          })
        })
      } catch (error) {
        console.error('获取新闻列表失败:', error)
        // 如果接口失败，使用默认数据
        this.newsItems = [
          {
            id: null,
            mediaType: null,
            image: require('../assets/images/demo_news_1.jpg'),
            title: '加载失败',
            desc: '数据加载失败，请稍后重试',
            date: ''
          }
        ]
        // 使用双重 $nextTick 确保 DOM 完全更新，并添加小延迟确保图片加载
        this.$nextTick(() => {
          this.$nextTick(() => {
            setTimeout(() => {
              this.initFiveSwiper()
            }, 100)
          })
        })
      }
    },
    // 首页新闻卡片跳转到详情页（新标签页）
    goToNewsDetail(item) {
      if (!item || !item.id) return
      const routeData = this.$router.resolve({
        path: '/show',
        query: {
          id: item.id,
          type: item.mediaType || undefined,
          from: 'news'
        }
      })
      window.open(routeData.href, '_blank')
    }
    ,
    // 首页「资质荣誉」查看更多：跳转到关于页的荣誉资质模块
    goToAboutHonors () {
      this.$router.push({
        path: '/about',
        hash: '#about_six'
      })
    },
    // 首页 slogan 按钮：在新标签页打开关于页
    goToAbout () {
      const routeData = this.$router.resolve({
        path: '/about'
      })
      window.open(routeData.href, '_blank')
    },
    goToProductView(type){
    console.log(type)
      let path = ''
      if(type==1){
        path = '/productOne'
      }else if(type==2){
        path = '/productTwo'
      }else if(type==3){
        path = '/productThree'
      }else if(type==4){
        path = '/productFour'
      }else if(type==5){
        path = '/productFive'
      }else if(type==6){
        path = '/productSix'
      }

      if (path) {
        // 使用 router.resolve 生成完整 URL，在新标签页打开
        const routeData = this.$router.resolve({ path })
        window.open(routeData.href, '_blank')
      }
  },
    goToProduct() {
      const routeData = this.$router.resolve({
        path: '/product'
      })
      window.open(routeData.href, '_blank')
    }
  },
  
  mounted () {
    // 先获取新闻数据，数据加载完成后再初始化 swiper
    this.fetchNewsList()
    this.$nextTick(() => {
      this.initBannerSwiper()
      this.initThreeMSwiper()
    })
  },
  beforeDestroy () {
    if (this.bannerSwiperInstance) {
      this.bannerSwiperInstance.destroy(true, true)
      this.bannerSwiperInstance = null
    }
    if (this.fiveSwiperInstance) {
      this.fiveSwiperInstance.destroy(true, true)
      this.fiveSwiperInstance = null
    }
    if (this.threeMSwiperInstance) {
      this.threeMSwiperInstance.destroy(true, true)
      this.threeMSwiperInstance = null
    }
  }
}
</script>
<style>

@import '../assets/css/index.css';

</style>


